import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Topbar from './Topbar';
import TwoFactorBanner from './TwoFactorBanner';
import '../DashboardHome/rush.css';
import '../DashboardHome/dashboard.css';
import '../DashboardHome/rush-fixes.css';

const RushShell = () => {
    useEffect(() => {
        document.body.classList.add('rs-shell-body');
        return () => document.body.classList.remove('rs-shell-body');
    }, []);

    return (
        <div className="rs-app">
            <Sidebar />
            <div className="rs-main">
                <Topbar />
                <TwoFactorBanner />
                <div className="rs-page">
                    <Outlet />
                </div>
            </div>
        </div>
    );
};

export default RushShell;
